import OapRoutineBuilder from './code/Scripts/Components/OapRoutineBuilder.vue';

export default {
  components: {
    OapRoutineBuilder,
  },
};
